import { Component, Vue } from 'vue-property-decorator'
import get from 'lodash/get'
import { ERRORS_ROUTES } from '@/views/Errors/utils'
import axios, { AxiosError, AxiosResponse } from 'axios'


@Component
export class AsyncData extends Vue {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public asyncData?: () => any;

  public isLoading!: boolean;

  public isLoadingAsyncData!: boolean;

  public async created() {
    const { asyncData } = this
    if (!asyncData) return
    this.isLoading = true
    this.isLoadingAsyncData = true

    try {
      await asyncData.call(this)
    } catch (e) {
      if (axios.isCancel(e)) return
      type Error = AxiosResponse & AxiosError

      const err = e as Error
      const code = get(err, 'code') || get(err, 'status')
      const message = get(err, 'message') || get(err, 'statusText')

      const errorRoute = {
        name: ERRORS_ROUTES.ERRORS,
        params: {
          code: `${code}`,
          message,
          fromRoute: this.$route.fullPath,
        },
      }

      void this.$router.replace(errorRoute)
    } finally {
      this.isLoading = false
      this.isLoadingAsyncData = false
    }
  }
}

export const initPlugin = () => {
  Vue.mixin({ mixins: [AsyncData] })
}
